import React from 'react';

import { useIntl } from 'react-intl';

import { type UIAnalyticsEvent } from '@atlaskit/analytics-next';
import { IconButton } from '@atlaskit/button/new';
import CurlyBracketsIcon from '@atlaskit/icon/core/curly-brackets';
import { token } from '@atlaskit/tokens';

import messages from './messages';

type DebugButtonProps = {
	onClick?: (event: UIAnalyticsEvent) => void;
};

export const DebugButton = ({ onClick }: DebugButtonProps): React.JSX.Element => {
	const { formatMessage } = useIntl();

	return (
		<IconButton
			isTooltipDisabled={false}
			label={formatMessage(messages.debugLabel)}
			type="button"
			onClick={(_, event: UIAnalyticsEvent) => onClick?.(event)}
			icon={(iconProps) => <CurlyBracketsIcon {...iconProps} color={token('color.icon.subtle')} />}
			appearance="subtle"
			spacing="default"
		/>
	);
};
